.loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  height: 100%;
  width: 100%;
  position: relative;
}
